import React, { PropsWithChildren } from 'react'
import { ReactFC } from 'common/types/ReactFC'
import FeatureItem from 'components/FeatureItem'
import RegulatoryRatings from 'components/RegulatoryRatings'
import ImageCard from 'components/cards/base/ImageCard'

const features = [
  {
    description:
      'We strictly comply with KYC/AML policies, enforced by a dedicated Compliance team. We are regulated as a Trust and Service Provider by the HMRC (AML no.12883542).',
    title: 'Regulatory compliance.',
  },
  {
    description:
      'A proven track record of successful collaborations with prominent banks such as Tide, ANNA, and other fintech partners. Not to mention our accounting partnerships. All in all, we have securely serviced over 100,000 customers to date without incident.',
    title: 'Fintech partnership.',
  },
  {
    description:
      'We are audited regularly, maintain certifications, provide industry-standard protections (ICO no. ZA041914).',
    title: 'Data Protection.',
  },
  {
    description:
      'Our Cyber Essentials and Cyber Essentials Plus certifications highlight our commitment to cybersecurity.',
    title: 'Uncompromised Security.',
  },
  {
    description:
      'Ready to provide Sample Commercial agreement, T&Cs, Business Continuity Plan, Data protection policies, Customer Support SLA, Complaints Policy, Service Level Agreement, and Proof of ID and address document checklist.',
    title: 'Transparency & Accountability.',
  },
]

type RegulatoryComplianceCardType = {
  className?: string
}

const RegulatoryComplianceCard: ReactFC<
  PropsWithChildren<RegulatoryComplianceCardType>
> = ({ className = '' }) => {
  return (
    <ImageCard
      shadow={false}
      roundedBox={false}
      imageLeft
      reverseColumnsMobile
      verticalAlign='end'
      padding='0'
      imageAlt='HaiRo™ robot mascot with cool stickers holding tie'
      image='/images/new/cool-robot-with-tie.png'
      imageDimensions={{ height: 737, width: 551 }}
      classNameForCol1='col-12 col-xxxl-6 pe-xxl-14 px-6'
      classNameForCol2='d-block col-6 offset-3 d-xxxl-block offset-xxxl-0 col-xxxl-6 ps-xxl-5'
    >
      <div className='d-flex flex-column gap-5 fs-fluid-16-20'>
        {features.map((feature) => (
          <FeatureItem
            key={feature.title}
            title={feature.title}
            description={feature.description}
          />
        ))}
      </div>
      <RegulatoryRatings />
    </ImageCard>
  )
}

export default RegulatoryComplianceCard
